<template>
  <v-card>
    <div class="fixed-toolbar-info">
      <slot name="toolbar_info"></slot>
    </div>

    <slot />
    <v-card-actions>
      <slot name="actions_defaut" v-if="showButton">
        <v-btn v-if="updateMode && deleteEnabled" @click="modalDelete = true">
          {{ $t('button.delete') }}</v-btn
        >
        <v-btn
          :loading="saving"
          type="submit"
          color="primary"
          @click="$emit('save')"
          >{{ saveLabel }}</v-btn
        >
      </slot>
      <slot name="actions_droit" />
      <v-spacer />
      <slot name="actions_gauche" />
    </v-card-actions>

    <c-dialog persistent :dialog="internalModalLeave" max-width="50%">
      <alert-leave
        :alertTitle="$t('leaveTitle')"
        :alertMessage="$t('leaveConfirm')"
        @confirm="
          $emit('closeLeave')
          $store.commit('modif/modified', false)
          next()
        "
        @cancel="$emit('closeLeave')"
      />
    </c-dialog>
  </v-card>
</template>

<script>
import i18n from '@/utils/i18n'
import Mousetrap from 'mousetrap'

export default {
  props: {
    updateMode: {
      type: Boolean,
      required: true,
    },
    deleteEnabled: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Function,
      default: () => {},
    },
    modalLeave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalModalLeave: false,
    }
  },
  computed: {
    saveLabel() {
      return i18n.t(this.updateMode ? 'button.save' : 'button.create')
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.updateMode) {
        Mousetrap.bind(['del', 'backspace'], () => {
          this.modalDelete = false
        })
      }
    })
  },
  watch: {
    modalLeave(val) {
      this.internalModalLeave = val
    },
  },
  beforeDestroy() {
    Mousetrap.unbind('del', 'backspace')
  },
}
</script>

<style scoped>
.v-btn--bottom:not(.v-btn--absolute) {
  bottom: 64px;
}

.fixed-toolbar-info {
  position: fixed;
  z-index: 10;
  top: 5px;
  right: 280px;
}
</style>
